import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';

import PAPDetails from 'pap/components/details';
import {
  fetchPricing, updateFeaturesRequest, updateAwardsRequest, fetchDiscountCode
} from 'pap/ducks/pricing';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import {
  createUserRequest, fetchCountriesIfNeeded, GET_USER_DATA_SUCCESS, logout
} from 'common/ducks/user';
import {
  displayFullScreen, hideFullScreen, changeStep, getDetailsSteps,
  changeSection, resetPAP, setLazyRegistering, toggleSelectPackageSubcat
} from 'pap/ducks/workflow';
import { createProjectRequest, updateProjectRequest } from 'pap/ducks/project';
import { selectCreative } from 'project/ducks/project_1_1';
import { createCustomContractRequest } from 'common/ducks/contract';
import { setUnhandledError } from 'error/ducks';
import { getSubCategory } from 'common/ducks/categories';
import { get1to1AwardFromForm, getDetailsStepLink, getCurrentStepIndex } from 'pap/utils';
import { showBanner } from 'common/ducks/banner';
import { setGoogleDimension } from 'common/tracking';
import {
  trackMixpanel, aliasWithMixpanel, identifyWithMixpanel, trackGoogle,
  setMixpanelProfile, mixpanelProfileFromCsProfile
} from 'common/tracking';

/*
 * Get selected package.
 * For 1-1 projects, there should be just one, so just pick it.
 * Otherwise, it's the one selected in the "package selection" step.
*/
const getSelectedPackage = (packages, formValues, oneToOne) => {
  if (oneToOne) {
    return (packages || [])[0]
  }
  return (packages || []).find((p) => p.id == formValues.package)
}

export function mapStateToProps(state, { params }) {
  const formValues = state.form['pap_details']? state.form['pap_details'].values || {} : {};
  const packages = state.pap.pricing.packages;
  const { subCategorySlug, categorySlug } = params;
  const categories = state.categories.data;
  const creative1to1 = state.project.projectPage.project1To1.selectedCreative;
  const selectedPackage = getSelectedPackage(packages, formValues, creative1to1);

  return {
    categorySlug: categorySlug,
    subCategorySlug: subCategorySlug,
    subCategory: getSubCategory({data: categories}, subCategorySlug),
    stepName: params.stepName,
    packages: packages,
    formValues: formValues,
    selectedPackage: selectedPackage,
    user: state.user,
    countries: state.user.countries,
    detailsSteps: getDetailsSteps(state, params),
    fullScreen: state.pap.workflow.fullScreen,
    categories: categories,
    creative1to1: creative1to1,
    awardValue1to1: get1to1AwardFromForm(formValues, selectedPackage),
    packageName: selectedPackage? selectedPackage.name : '',
    lazyRegistering: state.pap.workflow.lazyRegistering,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPricing,
    fetchCategoriesIfNeeded,
    fetchCountriesIfNeeded,
    createProjectRequest,
    updateProjectRequest,
    resetPAP,
    displayFullScreen,
    hideFullScreen,
    setUnhandledError,
    updateFeaturesRequest,
    updateAwardsRequest,
    createCustomContractRequest,
    setLazyRegistering,
    showBanner,
    fetchDiscountCode,
    logout,
    toggleSelectPackageSubcat,
    select1to1Creative: selectCreative,
    dispatch,
  }, dispatch);
}

/**
 * This is an async validation function that is used for both checking if an account exists with
 * given email and creating one if it doesn't.
 */
const tryCreateAccount = (values, dispatch, props, blurredField) => {
  const { detailsSteps, stepName, categorySlug, subCategorySlug, setLazyRegistering, router
    } = props;

  if (stepName !== 'create-account') {
    return Promise.resolve();
  }

  const newAccountValues = values[stepName] || {};
  const userData = {
    is_client: true,
    email: newAccountValues.email
  };
  const currentStepIdx = getCurrentStepIndex(detailsSteps, stepName);
  const nextStepLink = getDetailsStepLink(
    categorySlug, subCategorySlug, detailsSteps, currentStepIdx + 1
  );

  return createUserRequest(userData).then((response) => {
    aliasWithMixpanel(response.data.id);
    identifyWithMixpanel(response.data.id);
    setMixpanelProfile(response.data["email"], mixpanelProfileFromCsProfile(response.data), true);

    trackMixpanel("Registered", {
      "variant": "lazy",
      "userType": "client"
    });

    trackGoogle("registration", "registered", "client");

    dispatch({
      type: GET_USER_DATA_SUCCESS,
      data: response.data
    })
    if (response.data.user_converted_from) {
      // dimension1 = user_converted_from (defined in analytics)
      setGoogleDimension('dimension1', response.data.user_converted_from);
    }
    /* go to next step BEFORE calling `setLazyRegistering()` otherwise there will be rendering
       errors */
    router.push(nextStepLink);
    setLazyRegistering(false);
  }).catch(({ data }) => {
    let error = null;
    if (data.email) { error = { email: data.email[0] }; }
    throw { "create-account": error };
  })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'pap_details',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    asyncValidate: tryCreateAccount,
    asyncBlurFields: []
  })(PAPDetails)
), { withRef: true });



// WEBPACK FOOTER //
// ./pap/containers/details.jsx